import React from 'react';
import { ArrowRight, Download } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { ProjectCard } from '../components/ProjectCard';
import { ISOCertificateCard } from '../components/ISOCertificateCard';
import { SEO, OrganizationSchema, LocalBusinessSchema, WebSiteSchema } from '../components/SEO';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  const handleDownloadCompanyProfile = () => {
    window.open('https://drive.google.com/file/d/1uTnFz_7YzLi1HhnoG9POlSh5stVvcW9A/view?usp=sharing', '_blank', 'noopener,noreferrer');
  };
  return <>
      <SEO title="PT Wahana Konstruksi Mandiri - Kontraktor Konstruksi Terpercaya ISO Certified | WKM" description="PT Wahana Konstruksi Mandiri (WKM) adalah perusahaan konstruksi terpercaya di Kalimantan dengan sertifikasi ISO 9001, 14001, 45001, 37001. Spesialisasi dalam konstruksi gedung, infrastruktur, jalan, irigasi, drainase, dan BIM services. 44+ proyek terlaksana dengan komitmen pada kualitas dan keselamatan kerja (K3)." keywords="konstruksi Kalimantan, kontraktor terpercaya, WKM, Wahana Konstruksi Mandiri, ISO 9001, ISO 14001, ISO 45001, ISO 37001, BIM services, konstruksi gedung, infrastruktur, jalan, irigasi, drainase, Tanah Bumbu, Samarinda, kontraktor profesional, perusahaan konstruksi, jasa konstruksi, general contractor, construction company Indonesia" canonical="https://wkmkonstruksi.id" type="website" data-id="element-240" />
      <OrganizationSchema data-id="element-241" />
      <LocalBusinessSchema data-id="element-242" />
      <WebSiteSchema data-id="element-243" />

      <div className="flex flex-col" data-id="element-244">
        <section className="relative bg-gradient-to-br from-wkm-navy-900 via-wkm-navy-800 to-wkm-navy-900 text-white py-20 md:py-28 lg:py-36 overflow-hidden" data-id="element-245">
          <div className="absolute inset-0 bg-wkm-gold-500/5 z-0" data-id="element-246"></div>
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-247"></div>

          <div className="absolute top-20 right-20 w-72 h-72 bg-wkm-gold-500/10 rounded-full blur-3xl animate-pulse" data-id="element-248"></div>
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-wkm-gold-500/5 rounded-full blur-3xl" data-id="element-249"></div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-250">
            <div className="max-w-3xl" data-id="element-251">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-wkm-gold-500/10 border border-wkm-gold-500/30 text-wkm-gold-400 text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-252">
                <span className="w-2 h-2 bg-wkm-gold-400 rounded-full mr-2 animate-pulse" data-id="element-253"></span>
                Official Corporate Website
              </div>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-balance" data-id="element-254">
                Membangun Masa Depan dengan{' '}
                <span className="text-wkm-gold-400" data-id="element-255">Integritas</span> &{' '}
                <span className="text-wkm-gold-400" data-id="element-256">Kualitas</span>
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-wkm-slate-300 mb-8 max-w-2xl leading-relaxed" data-id="element-257">
                PT Wahana Konstruksi Mandiri (WKM) menghadirkan solusi
                konstruksi terintegrasi dengan standar ISO dan tata kelola
                perusahaan yang transparan.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-258">
                <Button size="lg" onClick={() => onNavigate('proyek')} aria-label="Lihat Portofolio Proyek" data-id="element-259">
                  Lihat Portofolio
                  <ArrowRight className="w-4 h-4 ml-2" data-id="element-260" />
                </Button>
                <Button variant="outline" size="lg" className="text-white border-white hover:bg-white/10" onClick={() => onNavigate('keterbukaan')} aria-label="Keterbukaan Informasi" data-id="element-261">
                  Keterbukaan Informasi
                </Button>
                <Button variant="gold" size="lg" onClick={handleDownloadCompanyProfile} aria-label="Download Company Profile PDF" data-id="element-262">
                  <Download className="w-4 h-4 mr-2" data-id="element-263" />
                  Company Profile
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 sm:py-12 bg-white border-b border-wkm-slate-200" aria-label="Statistik Perusahaan" data-id="element-264">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8" data-id="element-266">
              {[{
              value: '44+',
              label: 'Proyek Terlaksana'
            }, {
              value: '4',
              label: 'Sertifikasi ISO'
            }, {
              value: '100%',
              label: 'Komitmen K3'
            }, {
              value: '2021',
              label: 'Tahun Berdiri'
            }].map((stat, index) => <div key={index} className="text-center group" data-id="element-267">
                  <div className="text-3xl sm:text-4xl font-bold text-wkm-navy-700 mb-2 group-hover:text-wkm-gold-600 transition-colors duration-300" data-id="element-268">
                    {stat.value}
                  </div>
                  <div className="text-xs sm:text-sm text-wkm-slate-500 font-medium uppercase tracking-wide" data-id="element-269">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 bg-gradient-to-br from-wkm-navy-900 via-wkm-navy-800 to-wkm-navy-900 relative overflow-hidden" aria-label="Download Company Profile" data-id="element-270">
          <div className="absolute inset-0 bg-wkm-gold-500/5" data-id="element-271"></div>
          <div className="absolute top-0 right-0 w-96 h-96 bg-wkm-gold-500/10 rounded-full blur-3xl" data-id="element-272"></div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-273">
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 md:p-12 border border-wkm-gold-500/20" data-id="element-274">
              <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-275">
                <div className="flex-1 text-white" data-id="element-276">
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-wkm-gold-500/20 border border-wkm-gold-500/30 text-wkm-gold-300 text-xs font-bold uppercase tracking-wide mb-4" data-id="element-277">
                    <Download className="w-3 h-3 mr-2" data-id="element-278" />
                    Download Tersedia
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-bold mb-4" data-id="element-279">
                    Company Profile PT WKM
                  </h2>
                  <p className="text-wkm-slate-300 text-base sm:text-lg mb-6" data-id="element-280">
                    Unduh profil lengkap perusahaan kami yang berisi informasi
                    detail tentang layanan, proyek, sertifikasi, dan komitmen
                    kami terhadap kualitas konstruksi.
                  </p>
                  <ul className="space-y-2 text-sm sm:text-base text-wkm-slate-300 mb-8" data-id="element-281">
                    {['Profil Perusahaan Lengkap', 'Portofolio Proyek', 'Sertifikasi & Legalitas', 'Struktur Organisasi'].map((item, i) => <li key={i} className="flex items-center" data-id="element-282">
                        <span className="w-1.5 h-1.5 bg-wkm-gold-400 rounded-full mr-3 flex-shrink-0" data-id="element-283"></span>
                        {item}
                      </li>)}
                  </ul>
                  <Button variant="gold" size="lg" onClick={handleDownloadCompanyProfile} aria-label="Download Company Profile PDF" className="w-full sm:w-auto" data-id="element-284">
                    <Download className="w-5 h-5 mr-2" data-id="element-285" />
                    Download Company Profile (PDF)
                  </Button>
                </div>
                <div className="flex-shrink-0 hidden md:block" data-id="element-286">
                  <div className="w-64 h-80 bg-white/10 backdrop-blur-sm rounded-lg border border-wkm-gold-500/30 flex items-center justify-center shadow-2xl" data-id="element-287">
                    <div className="text-center text-white" data-id="element-288">
                      <Download className="w-16 h-16 mx-auto mb-4 text-wkm-gold-400" data-id="element-289" />
                      <p className="text-sm opacity-75 font-medium" data-id="element-290">
                        Company Profile
                      </p>
                      <p className="text-xs opacity-50 mt-2" data-id="element-291">PDF Document</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 bg-wkm-slate-50" aria-label="Keterbukaan Informasi" data-id="element-292">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-wkm-slate-200 flex flex-col md:flex-row" data-id="element-294">
              <div className="p-6 sm:p-8 md:p-12 md:w-2/3" data-id="element-295">
                <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wide mb-4" data-id="element-296">
                  Penting
                </div>
                <h2 className="text-2xl sm:text-3xl font-bold text-wkm-navy-900 mb-4" data-id="element-297">
                  Pusat Keterbukaan Informasi
                </h2>
                <p className="text-wkm-slate-600 mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-298">
                  Sebagai bentuk kepatuhan terhadap regulasi dan transparansi
                  publik, kami menyediakan akses lengkap terhadap dokumen
                  perusahaan, pengumuman material, dan informasi terkait proses
                  akuisisi & MTO.
                </p>
                <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4" data-id="element-299">
                  <Button onClick={() => onNavigate('keterbukaan')} aria-label="Akses Halaman Keterbukaan Informasi" className="w-full sm:w-auto" data-id="element-300">
                    Akses Halaman Keterbukaan
                    <ArrowRight className="w-4 h-4 ml-2" data-id="element-301" />
                  </Button>
                  <Button variant="outline" onClick={() => onNavigate('tata-kelola')} aria-label="Hubungi Corporate Secretary" className="w-full sm:w-auto" data-id="element-302">
                    Hubungi Corporate Secretary
                  </Button>
                </div>
              </div>
              <div className="bg-wkm-navy-900 p-6 sm:p-8 md:p-12 md:w-1/3 flex flex-col justify-center text-white" data-id="element-303">
                <h3 className="text-lg sm:text-xl font-bold mb-4" data-id="element-304">
                  Pengumuman Terbaru
                </h3>
                <ul className="space-y-4" data-id="element-305">
                  {[{
                  date: 'Hari ini',
                  title: 'Update Proses Mandatory Tender Offer (MTO)'
                }, {
                  date: 'Kemarin',
                  title: 'Laporan Kinerja Q3 2024'
                }].map((item, i) => <li key={i} className="border-b border-wkm-navy-700 pb-4 last:border-0 last:pb-0" data-id="element-306">
                      <span className="text-xs text-wkm-slate-400 block mb-1" data-id="element-307">
                        {item.date}
                      </span>
                      <a href="#" onClick={e => {
                    e.preventDefault();
                    onNavigate('keterbukaan');
                  }} className="hover:text-wkm-gold-400 transition-colors font-medium text-sm sm:text-base" data-id="element-308">
                        {item.title}
                      </a>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 sm:py-20 bg-white" aria-label="Proyek Unggulan" data-id="element-309">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-310">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-10 sm:mb-12 gap-4" data-id="element-311">
              <div data-id="element-312">
                <div className="inline-block px-3 py-1 bg-wkm-gold-100 text-wkm-gold-700 rounded-full text-xs font-semibold uppercase tracking-wide mb-4" data-id="element-313">
                  Portfolio
                </div>
                <h2 className="text-2xl sm:text-3xl font-bold text-wkm-navy-900 mb-3 sm:mb-4" data-id="element-314">
                  Proyek Unggulan
                </h2>
                <p className="text-wkm-slate-600 max-w-2xl text-sm sm:text-base" data-id="element-315">
                  Rekam jejak kami dalam menghadirkan infrastruktur berkualitas
                  di berbagai sektor.
                </p>
              </div>
              <Button variant="outline" className="hidden md:flex" onClick={() => onNavigate('proyek')} aria-label="Lihat Semua Proyek" data-id="element-316">
                Lihat Semua Proyek
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-317">
              <ProjectCard client="PT Jhonlin Baratama" project="Pekerjaan Workshop & Office Plant" location="Kalimantan Selatan" status="Completed" year="2023" image="https://cdn.magicpatterns.com/uploads/iH4SemqE4P8m5ZTG1aF8BH/Pekerjaan_Workshop__Office_Plant.png" data-id="element-318" />
              <ProjectCard client="Kemenhan" project="Pembangunan Barak & Pos Pamtas TNI" location="Perbatasan" status="On Progress" year="2024" image="https://cdn.magicpatterns.com/uploads/9BDcmsiqRHmX27yGRpCJZo/Pembangunan_Barak__Pos_Pamtas_TNI.png" data-id="element-319" />
              <ProjectCard client="PT Nusa Jaya Port" project="Pekerjaan Jetty & Mooring Dolphin" location="Kalimantan Selatan" status="Completed" year="2023" image="https://cdn.magicpatterns.com/uploads/meR517ZCaAEAWzWqbDnYzw/Pekerjaan_Jetty__Mooring_Dolphin.png" data-id="element-320" />
            </div>

            <div className="mt-8 md:hidden" data-id="element-321">
              <Button variant="outline" fullWidth onClick={() => onNavigate('proyek')} aria-label="Lihat Semua Proyek" data-id="element-322">
                Lihat Semua Proyek
              </Button>
            </div>
          </div>
        </section>

        <section className="py-16 sm:py-20 bg-wkm-slate-50" aria-label="Sertifikasi ISO" data-id="element-323">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
            <div className="text-center mb-12 sm:mb-16" data-id="element-325">
              <div className="inline-block px-3 py-1 bg-wkm-gold-100 text-wkm-gold-700 rounded-full text-xs font-semibold uppercase tracking-wide mb-4" data-id="element-326">
                Certifications
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-wkm-navy-900 mb-3 sm:mb-4" data-id="element-327">
                Standar & Sertifikasi
              </h2>
              <p className="text-wkm-slate-600 max-w-2xl mx-auto text-sm sm:text-base" data-id="element-328">
                Kami berkomitmen pada standar internasional dalam manajemen
                mutu, lingkungan, dan keselamatan kerja.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-329">
              <ISOCertificateCard code="ISO 9001:2015" title="Quality Management System" certNumber="2023-1-0062" expiryDate="27 Jun 2026" scope="Provision of civil construction for building, road, bridge, drainage..." data-id="element-330" />
              <ISOCertificateCard code="ISO 14001:2015" title="Environmental Management" certNumber="AMER26816" expiryDate="06 May 2026" scope="General Contractor for Building, Civil and Other Construction Works" data-id="element-331" />
              <ISOCertificateCard code="ISO 45001:2018" title="Occupational Health & Safety" certNumber="AMER26817" expiryDate="06 May 2026" scope="General Contractor for Building, Civil and Other Construction Works" data-id="element-332" />
              <ISOCertificateCard code="ISO 37001:2016" title="Anti-Bribery Management" certNumber="AMER25634" expiryDate="19 Mar 2026" scope="General Contractor for Building, Civil and Other Construction Works" data-id="element-333" />
            </div>
          </div>
        </section>
      </div>
    </>;
}